import { useFragmentEditorStore } from '../stores/useFragmentEditorStore';
import { EditorTitle } from './EditorTitle';
import { NoChunks } from './NoChunks';
import { EditorExpander } from './toolbar/Expander';

type Props = Record<string, never>;

export function EmptyEditor(p: Props) {
  const isExpanded = useFragmentEditorStore((state) => state.isExpanded);

  return (
    <div>
      <div className="mb-2 d-flex">
        <EditorTitle />
        <div className="d-flex flex-grow-1">
          <div className="d-inline-block ml-auto">
            <EditorExpander />
          </div>
        </div>
      </div>
      <NoChunks isExpanded={isExpanded} />
    </div>
  );
}
